
















import { Component, Vue, Prop } from 'vue-property-decorator';
import SubjectTable from '../../components/subjectTable/index.vue';

@Component({
  components: {
    SubjectTable,
  },
})
export default class Certification extends Vue {

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private data!: TypeCertification.CustomerStartupInfo;
  /** 表头定义 */
  private columns: TypeBase.TableColumn[] = [
    {
      title: this.t('账户编号'),
      dataIndex: 'account_code',
      width: 150,
    },
    {
      title: this.t('公司名称'),
      dataIndex: 'sign_body_name',
      filterEmpty: true,
      width: 180,
    },
    {
      title: this.t('企业地址'),
      dataIndex: 'company_address',
      filterEmpty: true,
      width: 200,
    },
    {
      title: this.t('注册国家/地区'),
      dataIndex: 'register_area_code_text',
      filterEmpty: true,
    },
    {
      title: this.t('联系人'),
      dataIndex: 'contact_name',
      filterEmpty: true,
    },
    {
      title: this.t('联系电话'),
      dataIndex: 'phone_number',
      filterEmpty: true,
    },
    {
      title: this.t('联系邮箱'),
      dataIndex: 'email',
      filterEmpty: true,
    },
    {
      title: this.t('签约业务'),
      dataIndex: 'sign_business_type_text',
      filterEmpty: true,
    },
    {
      title: this.t('主体状态'),
      scopedSlots: {
        customRender: 'sign_body_status_text',
      },
      width: 100,
      filterEmpty: true,
    },
    {
      title: this.t('账单模板'),
      dataIndex: 'bill_lang_type_text',
      filterEmpty: true,
    },
    {
      title: this.t('操作'),
      fixed: 'right',
      width: 150,
      scopedSlots: {
        customRender: 'operation',
      },
    },
  ];
  /**
   * 主体列表
   */
  private dataList: TypeCertification.RegisterProcessSignBodyResp[] = [];

}
